export default {
    data() {
        return {
            severityAliases: {
                e: 'error',
                s: 'success',
                w: 'warn',
                i: 'info'
            },
            httpStatus: {
                forbidden: 403,
                serviceUnavailable: 503
            }
        }
    },
    methods: {
        displayToast(detail = null, severity = this.severityAliases.e, error = null, summary = null, life = 5000) {
            if (severity && this.severityAliases[severity]) {
                severity = this.severityAliases[severity];
            }

            let status = error?.response?.status;

            switch (status) {
                case this.httpStatus.serviceUnavailable:
                    severity = this.severityAliases.e;
                    summary = this.$t('ToastMixin.Serviço indisponível');
                    detail = this.$t('ToastMixin.O servidor está fora do ar');
                    break;
                case this.httpStatus.forbidden:
                    severity = this.severityAliases.e;
                    summary = this.$t('ToastMixin.Acesso negado');
                    detail = this.$t('ToastMixin.Você não tem acesso a esta funcionalidade');
                    break;
            }

            this.$toast.add({
                severity,
                summary: summary ?? this.getDefaultSummary(severity),
                detail,
                life
            });
        },
        getDefaultSummary(severity) {
            let messages = {
                [this.severityAliases.e]: this.$t('ToastMixin.Erro'),
                [this.severityAliases.s]: this.$t('ToastMixin.Sucesso'),
                [this.severityAliases.w]: this.$t('ToastMixin.Atenção'),
                [this.severityAliases.i]: this.$t('ToastMixin.Informação')
            };
            return messages[severity] ?? '';
        }
    }
}
